__turbopack_context__.v({
  "settingsButton": "ChatInterface-module__wcd16a__settingsButton",
  "spin": "ChatInterface-module__wcd16a__spin",
  "spinning": "ChatInterface-module__wcd16a__spinning",
});
